import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { Navigate, useLocation, useNavigate } from 'react-router';
import { z } from 'zod';
import { ApiError } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { FormError, TextField } from '../forms/fields';

const schema = z.object({ email: z.string().trim().min(1, 'Enter your email'), password: z.string().min(1, 'Enter your password') });

export function LoginPage() {
  const { me, loading, login } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? '/';
  const [error, setError] = useState<string | null>(null);
  const form = useForm({ resolver: zodResolver(schema), defaultValues: { email: '', password: '' } });

  if (!loading && me) return <Navigate to={from} replace />;

  const submit = form.handleSubmit(async (v) => {
    setError(null);
    try {
      await login(v.email, v.password);
      nav(from, { replace: true });
    } catch (e) {
      if (e instanceof ApiError && e.status === 429) setError(e.message);
      else if (e instanceof ApiError && e.status === 401) setError('Invalid email or password');
      else setError('Could not sign in. Please try again.');
      form.setValue('password', '');
    }
  });

  return (
    <div className="mms-login d-flex align-items-center justify-content-center p-3">
      <Card className="shadow-sm" style={{ width: '100%', maxWidth: 400 }}>
        <Card.Body className="p-3 p-sm-4">
          <div className="text-center mb-4">
            <div className="mms-logo mx-auto mb-2" aria-hidden>M</div>
            <h1 className="h4 mb-0">Money Management System</h1>
            <p className="text-body-secondary small mb-0">Sign in to continue</p>
          </div>
          <Form noValidate onSubmit={submit}>
            <FormError message={error} />
            <TextField form={form} name="email" label="Email" type="email" inputMode="email" autoComplete="username" />
            <TextField form={form} name="password" label="Password" type="password" autoComplete="current-password" />
            <Button type="submit" className="w-100" disabled={form.formState.isSubmitting}>
              {form.formState.isSubmitting ? 'Signing in…' : 'Sign in'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
